import './bootstrap';

import { createApp } from 'vue'

import { library } from '@fortawesome/fontawesome-svg-core'
import { faImage, faBarcodeRead, faGlobe, faLanguage, faRotateLeft, faRotateRight, faUsersCrown, faUserMinus, faImages, faTrash, faPlus, faFileImport, faEye, faCamera, faTable, faUsers, faPlusCircle, faDatabase, faDownload, faSignOutAlt, faCheck, faTimes, faWindowClose, faArrowLeft, faMinusSquare, faPlusSquare, faUpload, faBan, faKey, faUserPlus } from '@fortawesome/pro-solid-svg-icons'
import { FontAwesomeIcon as Icon } from '@fortawesome/vue-fontawesome'

library.add(faImage, faBarcodeRead, faGlobe, faLanguage, faRotateLeft, faRotateRight, faUsersCrown, faUserMinus, faImages, faTrash, faPlus, faFileImport, faEye, faCamera, faTable, faUsers, faPlusCircle, faDatabase, faDownload, faSignOutAlt, faCheck, faTimes, faWindowClose, faArrowLeft, faMinusSquare, faPlusSquare, faUpload, faBan, faKey, faUserPlus)

import ArticlePhotoForm from './components/ArticlePhotoForm.vue';
import BarcodeScanner from './components/BarcodeScanner.vue';

const app = createApp({});

app.component('Icon', Icon);
app.component('ArticlePhotoForm', ArticlePhotoForm);
app.component('BarcodeScanner', BarcodeScanner);

const mountedApp = app.mount('#app');

window.addSpinerAndDisable = function(buttonId, message) {
    let button = document.querySelector(buttonId);
    button.innerHTML = `<span class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>${message}`;
    setTimeout(function () {
        button.classList.add('disabled')
    }, 1);
}

import './scripts/functions';
import './scripts/article-index-table';
import './scripts/backup-manager';
import './scripts/ajax-submit';

const Compress = require('compress.js').default;
window.compress = new Compress();

$(document).ready(function () {
    flatpickr('.js-flatpickr', {
        enableTime: false,
        time_24hr: true,
        minuteIncrement: 1,
        locale: {
            firstDayOfWeek: 1
        }
    });

    $('.select2').select2({
        theme: 'bootstrap4',
        allowClear: true
    });

    $('[data-toggle="tooltip"]').tooltip();
});
